const BETA_HOSTING_ORIGIN = 'https://owner-team-app-beta--coachwunder-5575d.europe-west4.hosted.app';
const BETA_APP_ORIGIN = 'https://beta.app.coachwunder.com';

/** Resolve the raw Beta entrypoint before any API or OAuth client initializes. */
export function canonicalAppUrl(href) {
  const current = new URL(href);
  if (current.origin !== BETA_HOSTING_ORIGIN) return null;

  const target = new URL(BETA_APP_ORIGIN);
  // OAuth state/PKCE storage belongs to the old origin. Restart on canonical Beta instead
  // of forwarding an unusable authorization code or transferring its session.
  if (/^\/oauth\/callback\/?$/.test(current.pathname)) {
    target.pathname = '/challenges';
  } else {
    target.pathname = current.pathname;
    target.search = current.search;
    target.hash = current.hash;
  }
  return target.href;
}

/** Keep main's module side effects behind the canonical-origin check. */
export function startOwnerTeamApp({ location, loadApp }) {
  const target = canonicalAppUrl(location.href);
  if (target) {
    location.replace(target);
    return;
  }
  return loadApp();
}
